export class NotificationPaneModel {
    public constructor(
        public type: string,
        public title: string,
        public text: string
    ) {
    }
}
